import { createContext, useContext } from 'react'

export type ScanMode = 'add' | 'remove'

export interface ScanModeState {
  mode: ScanMode
  setMode: (mode: ScanMode) => void
}

export const ScanModeContext = createContext<ScanModeState | null>(null)

export function useScanMode(): ScanModeState {
  const context = useContext(ScanModeContext)

  if (context === null) {
    throw new Error('useScanMode must be used inside ScanModeProvider')
  }

  return context
}
